module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.2f37da34.jpg";